import { ShipmentRowInterface } from 'common/types'

export const TLO_SINGLE_TRUCK_LIMITS = {
  weight: 45000,
  cube: 3500,
  palletSpaces: 26,
} as const

export type TloGroupSummary = {
  tloRefId: string
  totalShipments: number
  totals: {
    weight: number
    cube: number
    palletSpaces: number
  }
  limits: typeof TLO_SINGLE_TRUCK_LIMITS
  overages: {
    weight: number
    cube: number
    palletSpaces: number
  }
  isOverCapacity: boolean
}

export const buildTloGroupSummary = (
  tloRefId: string,
  shipments: Array<
    Pick<ShipmentRowInterface, 'totalWt' | 'totalVol' | 'pallet'>
  >,
): TloGroupSummary => {
  const totals = shipments.reduce(
    (result, shipment) => ({
      weight: result.weight + Number(shipment.totalWt || 0),
      cube: result.cube + Number(shipment.totalVol || 0),
      palletSpaces: result.palletSpaces + Number(shipment.pallet || 0),
    }),
    { weight: 0, cube: 0, palletSpaces: 0 },
  )

  const overages = {
    weight: Math.max(0, totals.weight - TLO_SINGLE_TRUCK_LIMITS.weight),
    cube: Math.max(0, totals.cube - TLO_SINGLE_TRUCK_LIMITS.cube),
    palletSpaces: Math.max(
      0,
      totals.palletSpaces - TLO_SINGLE_TRUCK_LIMITS.palletSpaces,
    ),
  }

  return {
    tloRefId,
    totalShipments: shipments.length,
    totals,
    limits: TLO_SINGLE_TRUCK_LIMITS,
    overages,
    isOverCapacity: Object.values(overages).some((value) => value > 0),
  }
}
